import React from "react";

export const meetings = [
    {
      "id": "67766a38e9fd876a5279c27a",
      "date": "2024-01-03",
      "time": "07:30",
      "title": "TIFO",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "gtheret@sfr.fr",
        "sebastien.legoff@selego.co",
        "guillaume.theret@selego.co"
      ],
      "meetLink": "https://meet.google.com/dyr-aokp-cyx",
      "hasRecording": true
    },
    {
      "id": "67766a39e9fd876a5279c2aa",
      "date": "2024-01-04",
      "time": "08:30",
      "title": "tifo",
      "duration": 30,
      "organizer": "thibault@selego.co",
      "attendees": [
        "louise@selego.co",
        "thibault@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/uis-uzam-eaw"
    },
    {
      "id": "67766a39e9fd876a5279c2c1",
      "date": "2024-01-04",
      "time": "11:00",
      "title": "tifo",
      "duration": 15,
      "organizer": "thibault@selego.co",
      "attendees": [
        "louise@selego.co",
        "thibault@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/gsw-jfau-pww"
    },
    {
      "id": "67766a3be9fd876a5279c320",
      "date": "2024-01-08",
      "time": "16:15",
      "title": "Tifo",
      "duration": 30,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "romain.vermot@tifo.eu",
        "eric.lassus@tifo.eu",
        "benjamin.chatelain@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/vai-mjuw-avj"
    },
    {
      "id": "67766a3be9fd876a5279c32f",
      "date": "2024-01-09",
      "time": "13:15",
      "title": "Sebastien x Romain",
      "duration": 45,
      "organizer": "romain.vermot@tifo.eu",
      "attendees": [
        "romain.vermot@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/zta-nvoi-pcu"
    },
    {
      "id": "67766a3be9fd876a5279c335",
      "date": "2024-01-09",
      "time": "17:00",
      "title": "Sebastien x Romain",
      "duration": 15,
      "organizer": "romain.vermot@tifo.eu",
      "attendees": [
        "romain.vermot@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/hzu-hqsa-dwz"
    },
    {
      "id": "67766a3be9fd876a5279c33e",
      "date": "2024-01-10",
      "time": "09:30",
      "title": "Laura Jacquin and Sébastien Le Goff",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "laura.jacquin@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/vep-qibv-xdy"
    },
    {
      "id": "67766a3ce9fd876a5279c356",
      "date": "2024-01-10",
      "time": "16:00",
      "title": "Tifo - suite",
      "duration": 60,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "romain.vermot@tifo.eu",
        "eric.lassus@tifo.eu",
        "benjamin.chatelain@tifo.eu",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co",
        "laura.jacquin@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/ecc-tnju-fiv"
    },
    {
      "id": "67766a3ce9fd876a5279c368",
      "date": "2024-01-11",
      "time": "11:15",
      "title": "update acquiz estimeo/matter/tifo/girci",
      "duration": 15,
      "organizer": "thibault@selego.co",
      "attendees": [
        "thibault@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/nhb-ghym-oba"
    },
    {
      "id": "67766a3de9fd876a5279c389",
      "date": "2024-01-12",
      "time": "11:00",
      "title": "TIFO",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "guillaume.theret@selego.co",
        "louisa@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/mpg-ndyt-zsp",
      "hasRecording": true
    },
    {
      "id": "67766a3ee9fd876a5279c3b9",
      "date": "2024-01-15",
      "time": "16:00",
      "title": "catchup ux tifo",
      "duration": 30,
      "organizer": "louisa@selego.co",
      "attendees": [
        "louisa@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/fqh-jnao-gkc"
    },
    {
      "id": "67766a3ee9fd876a5279c3c2",
      "date": "2024-01-15",
      "time": "18:15",
      "title": "Tifo - next",
      "duration": 15,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "eric.lassus@tifo.eu",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/gkb-bfgf-rut"
    },
    {
      "id": "67766a40e9fd876a5279c413",
      "date": "2024-01-19",
      "time": "11:30",
      "title": "tifo brief",
      "duration": 30,
      "organizer": "thibault@selego.co",
      "attendees": [
        "thibault@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/wqc-dumg-rnh"
    },
    {
      "id": "67766a41e9fd876a5279c449",
      "date": "2024-01-22",
      "time": "16:45",
      "title": "Sebastien / thibault tifo",
      "duration": 15,
      "organizer": "thibault@selego.co",
      "attendees": [
        "sebastien.legoff@selego.co",
        "thibault@selego.co"
      ],
      "meetLink": "https://meet.google.com/zwp-riya-bjt"
    },
    {
      "id": "67766a42e9fd876a5279c45b",
      "date": "2024-01-23",
      "time": "16:00",
      "title": "Tifo - Seb Thib Louise",
      "duration": 30,
      "organizer": "louise@selego.co",
      "attendees": [
        "louise@selego.co",
        "thibault@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/nqv-tvpz-fhu"
    },
    {
      "id": "67766a42e9fd876a5279c461",
      "date": "2024-01-24",
      "time": "07:00",
      "title": "Tifo - Sales",
      "duration": 20,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "eric.lassus@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/qra-iycx-oiv"
    },
    {
      "id": "67766a42e9fd876a5279c46d",
      "date": "2024-01-24",
      "time": "15:00",
      "title": "Point sales / growth",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "louise@selego.co",
        "romain.vermot@tifo.eu",
        "benjamin.chatelain@tifo.eu",
        "thibault@selego.co",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/jjs-xfad-btc",
      "hasRecording": true
    },
    {
      "id": "67766a42e9fd876a5279c479",
      "date": "2024-01-25",
      "time": "10:00",
      "title": "Tifo - fede / comites Ligues",
      "duration": 15,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/bcp-rszs-bqv"
    },
    {
      "id": "67766a42e9fd876a5279c485",
      "date": "2024-01-25",
      "time": "15:30",
      "title": "TIFO Fede bi-weekly",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "dominique.verdon.ext@tifo.eu",
        "louise@selego.co",
        "eric.lassus@tifo.eu",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/jnj-qjsx-bai"
    },
    {
      "id": "67766a43e9fd876a5279c497",
      "date": "2024-01-26",
      "time": "09:30",
      "title": "TIfo",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [],
      "meetLink": null
    },
    {
      "id": "67766a43e9fd876a5279c4b2",
      "date": "2024-01-29",
      "time": "13:00",
      "title": "tifo call",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [],
      "meetLink": null
    },
    {
      "id": "67766a44e9fd876a5279c4bb",
      "date": "2024-01-29",
      "time": "14:30",
      "title": "tifo call",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [],
      "meetLink": null
    },
    {
      "id": "67766a44e9fd876a5279c4be",
      "date": "2024-01-29",
      "time": "15:00",
      "title": "Tifo",
      "duration": 30,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "eric.lassus@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/jzq-ehck-wbm"
    },
    {
      "id": "67766a44e9fd876a5279c4cd",
      "date": "2024-01-30",
      "time": "09:00",
      "title": "tifo",
      "duration": 120,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [],
      "meetLink": null
    },
    {
      "id": "67766a44e9fd876a5279c4dc",
      "date": "2024-01-30",
      "time": "14:30",
      "title": "TIFO grands comptes",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "dominique.verdon.ext@tifo.eu",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/rjf-frtw-dzh",
      "hasRecording": true
    },
    {
      "id": "67766a47e9fd876a5279c54c",
      "date": "2024-02-05",
      "time": "13:00",
      "title": "Tifo - Outils sales et problématiques clubs",
      "duration": 30,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "louise@selego.co",
        "romain.vermot@tifo.eu",
        "eric.lassus@tifo.eu",
        "benjamin.chatelain@tifo.eu",
        "dominiqueverdon@orange.fr",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/huz-yium-erf"
    },
    {
      "id": "67766a48e9fd876a5279c567",
      "date": "2024-02-06",
      "time": "14:30",
      "title": "TIFO grands comptes",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "dominique.verdon.ext@tifo.eu",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/rjf-frtw-dzh"
    },
    {
      "id": "67766a48e9fd876a5279c56d",
      "date": "2024-02-06",
      "time": "15:30",
      "title": "Data Product",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "louise@selego.co",
        "jp.roemer@tifo.eu",
        "benjamin.chatelain@tifo.eu",
        "sebastien.legoff@selego.co",
        "romain.vermot@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/qys-ikou-wrh"
    },
    {
      "id": "67766a49e9fd876a5279c5b5",
      "date": "2024-02-08",
      "time": "14:30",
      "title": "TIFO grands comptes",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "dominique.verdon.ext@tifo.eu",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/rjf-frtw-dzh"
    },
    {
      "id": "67766a4ae9fd876a5279c5e5",
      "date": "2024-02-09",
      "time": "16:30",
      "title": "Actions commerciales",
      "duration": 30,
      "organizer": "eric.lassus@tifo.eu",
      "attendees": [
        "louise@selego.co",
        "eric.lassus@tifo.eu",
        "benjamin.chatelain@tifo.eu",
        "dominiqueverdon@orange.fr",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co",
        "romain.vermot@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/evn-apvd-vct"
    },
    {
      "id": "67766a4be9fd876a5279c609",
      "date": "2024-02-12",
      "time": "16:00",
      "title": "Actions commerciales",
      "duration": 30,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "louise@selego.co",
        "romain.vermot@tifo.eu",
        "eric.lassus@tifo.eu",
        "benjamin.chatelain@tifo.eu",
        "dominiqueverdon@orange.fr",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/tmn-idqq-fxu"
    },
    {
      "id": "67766a4ee9fd876a5279c68a",
      "date": "2024-02-16",
      "time": "16:30",
      "title": "Actions commerciales",
      "duration": 30,
      "organizer": "eric.lassus@tifo.eu",
      "attendees": [
        "louise@selego.co",
        "eric.lassus@tifo.eu",
        "benjamin.chatelain@tifo.eu",
        "dominiqueverdon@orange.fr",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co",
        "romain.vermot@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/evn-apvd-vct"
    },
    {
      "id": "67766a4fe9fd876a5279c6c3",
      "date": "2024-02-21",
      "time": "07:30",
      "title": "Tifo cadrage tech / features / demo",
      "duration": 30,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "eric.lassus@erlinvest.com",
        "eric.lassus@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/dsr-sjeq-fng"
    },
    {
      "id": "67766a57e9fd876a5279c819",
      "date": "2024-03-11",
      "time": "13:00",
      "title": "Tifo - Point d'équipe hebdo",
      "duration": 30,
      "organizer": "louise@selego.co",
      "attendees": [
        "louise@selego.co",
        "romain.vermot@tifo.eu",
        "eric.lassus@tifo.eu",
        "benjamin.chatelain@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu",
        "bertrand.jung@tifo.eu",
        "dominiqueverdon@orange.fr",
        "jp.roemer@tifo.eu",
        "laura.jacquin@tifo.eu",
        "stephane.demagalhaes@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/hht-eavg-unk"
    },
    {
      "id": "67766a5ce9fd876a5279c8dc",
      "date": "2024-03-20",
      "time": "08:30",
      "title": "Antoine x Seb",
      "duration": 15,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "antoine@selego.co",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/cth-yvrc-gwa"
    },
    {
      "id": "67766a63e9fd876a5279ca15",
      "date": "2024-04-05",
      "time": "10:00",
      "title": "Point mensuel sales Tifo (clubs / comités / fédés)",
      "duration": 30,
      "organizer": "louise@selego.co",
      "attendees": [
        "louise@selego.co",
        "antoine@selego.co",
        "benjamin.chatelain@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/jje-gcpe-mdv"
    },
    {
      "id": "67766a63e9fd876a5279ca2d",
      "date": "2024-04-08",
      "time": "09:00",
      "title": "Rencontre fédération de Danse en présentiel",
      "duration": 60,
      "location": "20 Rue Saint-Lazare, 75009 Paris, France",
      "organizer": "antoine@selego.co",
      "attendees": [
        "dominique.verdon.ext@tifo.eu",
        "antoine@selego.co",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/ijn-cnhw-pxs"
    },
    {
      "id": "67766a6be9fd876a5279cba4",
      "date": "2024-04-29",
      "time": "07:00",
      "title": "",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "marguerite-laurent@hotmail.fr",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/azx-wthe-kij"
    },
    {
      "id": "67766a7ee9fd876a5279ced2",
      "date": "2024-06-06",
      "time": "13:15",
      "title": "tifo & estimeo",
      "duration": 45,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "sebastien.legoff@selego.co",
        "noemie@selego.co"
      ],
      "meetLink": "https://meet.google.com/bny-ynpt-gph"
    },
    {
      "id": "67766a81e9fd876a5279cf6b",
      "date": "2024-06-13",
      "time": "08:30",
      "title": "sebastien di mauro and Sébastien Le Goff",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/pkc-ozdc-pqu"
    },
    {
      "id": "67766a84e9fd876a5279cfec",
      "date": "2024-06-18",
      "time": "15:00",
      "title": "Seba x Seb",
      "duration": 60,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/vhi-pueh-ecy"
    },
    {
      "id": "67766a84e9fd876a5279cff2",
      "date": "2024-06-18",
      "time": "16:00",
      "title": "Point Seb Dev - eric",
      "duration": 60,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "eric.lassus@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/xwv-iomn-nag"
    },
    {
      "id": "67766a85e9fd876a5279d019",
      "date": "2024-06-20",
      "time": "08:00",
      "title": "sebastien di mauro and Sébastien Le Goff",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/xsc-vrzv-vxn"
    },
    {
      "id": "67766a88e9fd876a5279d0c1",
      "date": "2024-06-27",
      "time": "09:30",
      "title": "soumission KYC FINENSE",
      "duration": 30,
      "organizer": "bernard@finense.eu",
      "attendees": [
        "romain.vermot@tifo.eu",
        "bernard@finense.eu",
        "clement@finense.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/iyp-moao-sez",
      "hasRecording": true
    },
    {
      "id": "67766a8ce9fd876a5279d145",
      "date": "2024-07-02",
      "time": "11:30",
      "title": "Seba X Seb",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/xde-irkb-oco"
    },
    {
      "id": "67766a95e9fd876a5279d2ec",
      "date": "2024-07-16",
      "time": "09:00",
      "title": "tifo",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/tjc-trqt-tmq"
    },
    {
      "id": "6776737a92f2226fbd3bffb9",
      "date": "2023-05-19",
      "time": "08:00",
      "title": "Sebastien Di Mauro and Sébastien Le Goff",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "sebastiendimauro@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/rge-wnvg-mfs"
    },
    {
      "id": "6776737a92f2226fbd3bffbf",
      "date": "2023-05-19",
      "time": "15:00",
      "title": "Tifo x Le Stud",
      "duration": 60,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "maxime@selego.co",
        "eric.lassus@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/uzq-ihck-ydd"
    },
    {
      "id": "6776737a92f2226fbd3bffd7",
      "date": "2023-05-23",
      "time": "08:30",
      "title": "TIFO",
      "duration": 25,
      "organizer": "se.legoff@gmail.com",
      "attendees": [
        "sebastien.legoff@selego.co",
        "se.legoff@gmail.com"
      ],
      "meetLink": "https://meet.google.com/ced-xikd-jrz"
    },
    {
      "id": "6776737a92f2226fbd3bffda",
      "date": "2023-05-23",
      "time": "09:00",
      "title": "Tifo - Point",
      "duration": 15,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/trf-bkpg-zir"
    },
    {
      "id": "6776737c92f2226fbd3c0025",
      "date": "2023-05-26",
      "time": "07:30",
      "title": "Seb vs Seb - New project",
      "duration": 30,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/yfe-qdyi-upw"
    },
    {
      "id": "6776737d92f2226fbd3c0034",
      "date": "2023-05-26",
      "time": "09:30",
      "title": "Tifo - Audit +...",
      "duration": 60,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "eric.lassus@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu",
        "maxime@selego.co",
        "samuel.pires.pro@gmail.com"
      ],
      "meetLink": "https://meet.google.com/hys-qvbt-tbn"
    },
    {
      "id": "6776737d92f2226fbd3c0052",
      "date": "2023-05-29",
      "time": "14:30",
      "title": "le stud <> Tifo",
      "duration": 30,
      "organizer": "maxime@selego.co",
      "attendees": [
        "maxime@selego.co",
        "eric.lassus@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/rdp-fcnn-iac"
    },
    {
      "id": "6776737e92f2226fbd3c0082",
      "date": "2023-05-31",
      "time": "15:30",
      "title": "Tifo debrief",
      "duration": 60,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "samuel.pires.pro@gmail.com",
        "eric.lassus@tifo.eu",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/rwu-ekct-wqs"
    },
    {
      "id": "6776737f92f2226fbd3c008b",
      "date": "2023-06-01",
      "time": "08:00",
      "title": "le stud <> projet X",
      "duration": 30,
      "organizer": "maxime@selego.co",
      "attendees": [
        "maxime@selego.co",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/jwu-jyne-dkp"
    },
    {
      "id": "6776738292f2226fbd3c0113",
      "date": "2023-06-09",
      "time": "09:45",
      "title": "le stud <> Tifo",
      "duration": 30,
      "organizer": "maxime@selego.co",
      "attendees": [
        "maxime@selego.co",
        "hugo.kessler@selego.co",
        "eric.lassus@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/hdn-sxwd-exi"
    },
    {
      "id": "6776738992f2226fbd3c021b",
      "date": "2023-07-03",
      "time": "14:30",
      "title": "le stud x tifo",
      "duration": 45,
      "organizer": "maxime@selego.co",
      "attendees": [
        "maxime@selego.co",
        "hugo.kessler@selego.co",
        "samuel.pires.pro@gmail.com",
        "eric.lassus@tifo.eu",
        "sebastien.legoff@selego.co",
        "sebastien.dimauro@tifo.eu"
      ],
      "meetLink": "https://meet.google.com/wei-fubh-iyj"
    },
    {
      "id": "677674e80ced0970dcf07d0f",
      "date": "2023-12-05",
      "time": "16:10",
      "title": "Debrief Tifo Teeps Eric",
      "duration": 30,
      "organizer": "maxime@selego.co",
      "attendees": [
        "maxime@selego.co",
        "samuel.pires.pro@gmail.com",
        "thibault@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/ifh-bqbv-oca",
      "hasRecording": true
    },
    {
      "id": "677674e80ced0970dcf07d2d",
      "date": "2023-12-07",
      "time": "09:30",
      "title": "Tifo - Comité de pilotage - Produit / stratégie commerciale",
      "duration": 60,
      "organizer": "sebastien.dimauro@tifo.eu",
      "attendees": [
        "samuel.pires@tifo.eu",
        "dominiqueverdon@orange.fr",
        "sebastien.dimauro@tifo.eu",
        "benjamin.chatelain@tifo.eu",
        "eric.lassus@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/vgd-pfej-xgi"
    },
    {
      "id": "677674e90ced0970dcf07d3f",
      "date": "2023-12-08",
      "time": "08:10",
      "title": "Catch up",
      "duration": 20,
      "organizer": "eric.lassus@tifo.eu",
      "attendees": [
        "eric.lassus@tifo.eu",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/dbw-ying-nfz"
    },
    {
      "id": "677674ea0ced0970dcf07d75",
      "date": "2023-12-12",
      "time": "08:30",
      "title": "Hugo tifo and Sébastien Le Goff",
      "duration": 30,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "hugo.lecourt@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/pwr-uutk-aak",
      "hasRecording": true
    },
    {
      "id": "677674ea0ced0970dcf07d78",
      "date": "2023-12-12",
      "time": "09:00",
      "title": "Weekly Tifo X LeStud",
      "duration": 45,
      "organizer": "samuel.pires.pro@gmail.com",
      "attendees": [
        "hugo.kessler@selego.co",
        "samuel.pires.pro@gmail.com",
        "eric.lassus@tifo.eu",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/qic-vsjp-ogo"
    },
    {
      "id": "677674ea0ced0970dcf07d81",
      "date": "2023-12-12",
      "time": "15:00",
      "title": "Point tech",
      "duration": 60,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "eric.lassus@tifo.eu",
        "sebastien.dimauro@tifo.eu",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/xea-okwy-uci",
      "hasRecording": true
    },
    {
      "id": "677674eb0ced0970dcf07d90",
      "date": "2023-12-13",
      "time": "14:30",
      "title": "Tifo discovery",
      "duration": 30,
      "organizer": "thibault@selego.co",
      "attendees": [
        "maxime@selego.co",
        "augustin.stephan.pro@gmail.com",
        "samuel.pires.pro@gmail.com",
        "hugo.charon@selego.co",
        "thibault@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/fbr-cmer-ace",
      "hasRecording": true
    },
    {
      "id": "677674eb0ced0970dcf07dae",
      "date": "2023-12-14",
      "time": "14:30",
      "title": "TIFO ARCHI",
      "duration": 60,
      "organizer": "sebastien.legoff@selego.co",
      "attendees": [
        "hugo.kessler@selego.co",
        "deborah.jace@selego.co",
        "hugo.lecourt@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/dta-njdk-faj",
      "hasRecording": true
    },
    {
      "id": "677674ec0ced0970dcf07dc6",
      "date": "2023-12-18",
      "time": "09:30",
      "title": "tifo",
      "duration": 30,
      "organizer": "deborah.jace@selego.co",
      "attendees": [
        "guillaume.theret@selego.co",
        "deborah.jace@selego.co",
        "hugo.lecourt@selego.co",
        "sebastien.legoff@selego.co"
      ],
      "meetLink": "https://meet.google.com/hyd-hhya-anp"
    }
  ];

// Default component for routing
export default function Data() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Data Page</h1>
      <p>This is a placeholder for the data page. The meetings data is exported from this file.</p>
    </div>
  );
}